export const amplitudeTimeZone = 'Asia/Tokyo';
